<template>
  <resizable-common-dialog
      ref="dialog"
      title="Group"
      :dialog-visible.sync="visible"
      rules="rules"
      start-dialog-height="230"
      start-dialog-width="320"
  >
    <template v-slot:body>
      <v-row dense>
        <v-row dense class="mt-3">
          <v-col cols="12" md="12" sm="12">
            <v-combobox
                label="Name:"
                v-model.trim="model.name"
                :items="existingGroups"
                v-ascii-only
                dense
                :search-input.sync="searchInput"
            />
          </v-col>
        </v-row>
      </v-row>
    </template>

    <template v-slot:actions>
      <v-btn @click="hide" color="blue darken-1" text>Cancel</v-btn>
      <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
    </template>
  </resizable-common-dialog>
</template>
<script>
import ResizableCommonDialog from "@/modules/common/dialog/resizable-common-dialog.vue";
import {ViewRules} from "@/common/ViewRules";
import {GroupModel} from "@/modules/mconfigs/models/GroupModel";
import BranchStoreUtils from "@/modules/mconfigs/database/BranchStoreUtils";

export default {
  name: "c-group-dialog",
  components: {ResizableCommonDialog},
  data: () => ({
    visible: false,
    rules: ViewRules.READONLY,
    model: null,
    resolve: null,
    reject: null,
    searchInput: null,
  }),
  computed: {
    existingGroups() {
      const branches = BranchStoreUtils.getValues() || [];
      return [...new Set(branches.flatMap(b => b.groups).map(g => g.name).filter(Boolean))];
    },
  },
  methods: {
    show(rules, model) {
      this.model = model || new GroupModel();
      this.rules = rules;
      this.searchInput = null;
      this.visible = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    hide() {
      this.visible = false;
    },
    save() {
      this.resolve && this.resolve(this.model);
      this.visible = false;
    },
  },
};
</script>
